import React, { useId } from 'react';
import { COLORWAYS, WORDMARK, svgId } from '@/lib/synexLogo';

/**
 * The Synex wordmark in one of the brand's colourways (lib/synexLogo.js):
 * `primary` on light grounds, `white` on dark ones. Its gradient's id is
 * unique to each copy: a url(#id) resolves to the first element with that
 * id, so a hidden first copy would leave every other one without its sweep.
 */
export default function ApplicationLogo({ colorway = 'primary', className }) {
  const gradientId = svgId('synex-logo', useId());
  const { ink, from, to } = COLORWAYS[colorway];

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${WORDMARK.width} ${WORDMARK.height}`} fill="none" className={className}>
      {WORDMARK.letters.map(({ d, evenOdd }) => (
        <path key={d} d={d} fill={ink} {...(evenOdd ? { fillRule: 'evenodd', clipRule: 'evenodd' } : {})} />
      ))}
      <path d={WORDMARK.bar} fill={ink} />
      <path d={WORDMARK.sweep} fill={`url(#${gradientId})`} />
      <defs>
        <linearGradient id={gradientId} {...WORDMARK.gradient} gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
}
